import dlv from 'dlv';
import { FieldActions } from './fieldactions';


export function fieldPathForAction(field, action) {
	const parentPath = (action && action.path) && 
		action.action === FieldActions.Rename 
			? getParentPath(action.path) 
			: action.path;
	return parentPath ? `${parentPath}.${field}` : field;
}

export function nameFromPath(path) {
	if(path.indexOf('.') > 0 ) {
		const steps = path.split('.');
		return steps[steps.length-1];
	} else {
		return path;
	}
}

export function getParentPath(path) {
	const pathSteps = path.split('.');
	return pathSteps.length <= 1 ? '' : pathSteps.slice(0,-1).join('.');
}

export function getArrayIndexForPath(path) {
	const pathSteps = path.split('.');
	const r =  parseInt(pathSteps[pathSteps.length-1]);
	return r;
}

export function getObjectForPath(data, path) {
	if(!path.trim()) return data;
	return dlv(data, path);
}

export function fieldNameHasReservedChars(fieldName) {
	return !(/\.|\[|\]/.test(fieldName));
}

export function objectPathExists(obj, path) {
	return dlv(obj, path);
}